<template>
  <div style="height: 100%; display: flex; flex-direction: column;">
    <div style="height: 45%; display: flex; flex-direction: column;">
      <gj-area-title>成本计算方式设置</gj-area-title>
      <gj-table
          name="storageArgs"
          adaptParent
          :data="tableData"
          :columns="columns"
          :adapt-height="false"
          :show-overflow="false"
          :loading="loading">
        <template v-slot:content="{ row }">
          <gj-select
              v-model="row.content"
              ref="finacecostselect"
              :options="[
                {id: 'MONTHLY_FIXED_COST', text: '月度固定成本'},
                {id: 'BATCH_COST', text: '先进先出成本'}
              ]"
              :clearable="false"
              width="200px"
              @input="updateConfig($event, row)">
          </gj-select>
        </template>
      </gj-table>
    </div>
    <div style="height: 55%">
      <cost-average></cost-average>
    </div>
    <template>
        <new-user-guide v-if="userGuideState" ref="newUserGuide"></new-user-guide>
      </template>
  </div>
</template>

<script>
  import {queryMixin, responseMixin, userGuideMixin} from "@/minxins";
  import {apiSupplyFinanceAndCostQuery, apiSupplyFinanceAndCost} from "@/api/setting";
  import {isMeaningful} from "@/utils/common";
  import CostAverage from './cost-average'
  import GjLogModal from "@/components/modal/gj-log-modal";
  import NewUserGuide from "./components/new-user-guide"

  export default {
    name: "app-finance-cost",
    mixins: [queryMixin, responseMixin, userGuideMixin],
    components:{CostAverage, NewUserGuide},
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '参数名称', field: 'option:name', minWidth: '200px', options: [
            {id: 'COST_CALCULATION_METHOD', text: '成本方式'}
          ]},
          {id: 'content', header: '配置项', field: 'slot:content', minWidth: '200px'},
          {id: 'memo', header: '指标配置说明', field: 'memo', minWidth: '400px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
        ],

      }
    },
    methods: {
      updateConfig(content, row) {
        apiSupplyFinanceAndCost({
          id: row.id,
          content,
          memo: row.memo
        }).then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('更新成功');
               if(this.userGuideState) {
                if (content == 'MONTHLY_FIXED_COST'){
                    this.userGuideNextStep()
                }else {
                    this.$router.push({path: `/finance/batch-management?taskStatus=${this.userGuideTaskItem.taskStatus}`})
                }
               }
            });
          });
      },
      $gjQuery() {
        // 查询
        this.loading = true;
        apiSupplyFinanceAndCostQuery()
          .then((res) => {
            if (isMeaningful(res.data)) {
              this.tableData = res.data;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
            if (this.userGuideState) {
              this.$refs.finacecostselect.$children[0].focus()
            }
            
          });
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .gj-area-title {
    margin-bottom: 12px;
  }
  /deep/ .text-alert{
    margin-top: 0;
    margin-bottom: 10px;
  }
</style>
